<template>
  <div class="modal fade" tabindex="-1" role="dialog"  aria-hidden="true" :id="modalId">
    <div v-if="show === true" class="modal-dialog modal-lg">
      <form v-on:submit="verify">
        <div class="modal-content">
          <div class="modal-header" style=" padding: 20px 15px; ">
            <div class="span-12 text-right"><a class="closebox" data-dismiss="modal" aria-hidden="true"><i class="fa fa-times"></i></a></div>
            <h4 class="modal-title" style="font-weight: 600;">Verify protection</h4>
            <span class="font-bold">Generate a Proof of Existence of your file</span>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-xs-12">
                <div class="alert-info p-xs text-primary">
                  <i class="fa fa-info-circle fa-1x text-warning"></i> Please enter your Hash code Or upload your file and generate one and click Verify button. <a class="text-warning" @click="openSupport()">Contact our support</a> if needed help.
                </div>
              </div>
            </div>

            <form class="form-horizontal">
              <div class="form-group m-t-lg">
                <div class="col-xs-12 text-center">
                  <label class="btn btn-primary btn-outline btn-sm file-uploads file-uploads-html5"><i class="fa fa-plus"></i>
                    Choose a file
                    <input type="file" name="picture" style="display: none"  @change="onChangeFile($event)"></label>
                  <span style="margin-left: 50px" v-if="uploadFile">{{this.uploadFile.name}}</span>
                  <div>
                    <label v-if="errorFile" class="has-error text-danger">{{ errorFile }}</label>
                  </div>
                </div>
              </div>

              <div class="form-group m-t-lg">
                <div class="col-xs-12">
                  <div class="dividerWrapper">
                    <div class="dividerContent">OR</div>
                  </div>
                </div>
              </div>

              <div class="form-group m-t-lg">
                <label for="hashData" class="col-xs-3 control-label">Hash Code</label>
                <div class="col-xs-9">
                  <input type="" v-model="hashData" id="hashData" class="form-control" name="hashData" >
                  <span v-if="errorHashData" class="text-danger">{{ errorHashData }}</span>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col-xs-6 text-center">
                <button type="button" class="btn btn-default" data-dismiss="modal" >Cancel</button>
              </div>
              <div class="col-xs-6 text-center">
                <vue-ladda type="submit" :loading="btnSubmit.loading" class="btn btn-info" :data-style="btnSubmit.dataStyle">Verify protection</vue-ladda>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <limit-plan ref="limitPlan" :on-hidden="() => $emit('input', null)"></limit-plan>
  </div>
</template>
<style>
.dividerWrapper {
  width: 100%;
  height: 20px;
  border-bottom: 1px solid #eaeaea;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.dividerContent {
  background-color: #fff;
  padding: 0 20px;
  margin-top: 1em;
}
</style>

<script>

import VueLadda from 'vue-ladda'
import UploadFile from '../question/UploadFile'
import LimitPlan from '../../components/LimitPlan'

export default {
  components: {
    VueLadda,
    UploadFile,
    LimitPlan
  },
  props: ['value'],
  name: 'VerifyTimestamp',
  data () {
    return {
      modalId: null,
      show: false,
      errorHashData: null,
      hashData: null,
      errorFile: null,
      uploadFile: null,
      btnSubmit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      btnHash: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  methods: {
    verify: function (e) {
      e.preventDefault()
      this.errorHashData = null
      this.errorFile = null

      let data = new FormData()
      if (this.uploadFile !== null) {
        data.append('file', this.uploadFile)
      } else if (this.hashData !== null) {
        data.append('hash', this.hashData)
      } else {
        this.errorHashData = 'Please enter Hash code Or upload your file and generate one'
        this.errorFile = 'Please enter Hash code Or upload your file and generate one'
      }

      this.btnSubmit.loading = true

      if (this.errorHashData === null && this.errorFile === null) {
        this.axios.post('/timestamped/verify/', data).then((response) => {
          this.errorHashData = null
          if (response.data) {
            if (response.data.timestamped_file !== null) {
              $('#' + this.modalId).modal('hide')
              this.$router.push({name: 'TimestampedFileCertification', params: {poe_id: response.data.timestamped_file.id}})
            }
          } else {
            this.errorHashData = 'Document exist but it not protected'
            this.$notify({
              type: 'warning',
              title: this.errorHashData,
              placement: 'bottom-right'
            })
          }
          this.btnSubmit.loading = false
        }).catch((error) => {
          if (this.uploadFile !== null) {
            this.errorFile = 'Failed protection verification: no found file'
          } else {
            this.errorHashData = 'Failed protection verification: no found hash code'
          }
          if (typeof error.response !== 'undefined') {
            this.$notify({
              type: 'warning',
              title: 'Failed protection verification: no found hash code / file',
              placement: 'bottom-right'
            })
          }
          this.btnSubmit.loading = false
        })
      } else {
        this.btnSubmit.loading = false
      }
    },
    openSupport: function () {
      let iframe = document.getElementById('launcher')
      let supportButton = iframe.contentWindow.document.querySelector('#Embed button')

      if (typeof supportButton !== 'undefined') {
        supportButton.click()
      }
    },
    onChangeFile: function (event) {
      this.uploadFile = event.target.files[0]
    },
    openModal: function () {
      this.show = true
      this.btnSubmit.loading = false

      setTimeout(() => {
        $('#' + this.modalId).modal('show')
      }, 200)

      $('#' + this.modalId).on('hide.bs.modal', () => {
        this.show = false
        this.errorFile = null
        this.errorHashData = null
        this.uploadFile = null
        this.hashData = null
      })
    }
  },
  beforeMount () {
    this.modalId = '_' + Math.random().toString(36).substr(2, 9)

    if (this.value) {
      this.hashData = this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Timestamp/VerifyTimestamp.vue